<div class="firebaseui-container">
	<div id="firebaseui-auth-container"></div>
</div>